<div class="w-100">
    <mwp-card-content-header [url]="apiUrl" />
    <div>
        <mwp-table [tableColumns]="w2Columns" [dataSource]="w2MatTableData" (emitButtonSelection)="downloadW2($event)" (emitButtonSelection2)="emailDocument($event)" header="W2 Forms" />
    </div>
</div>